import { useT } from '@/phrase/hooks/useT'
import CardsLayout from '@/ui/home/CardsLayout'
import QRCode from 'react-qr-code'

interface QRCodeGeneratorProps {
  url: string
  title: string
}

export default function QRCodeGenerator({ url, title }: QRCodeGeneratorProps) {
  const t = useT()

  if (!url) {
    return null
  }

  return (
    <>
      <CardsLayout
        className={`flex-1  md:min-h-[268px]  md:h-[268px]    rounded-[20px] !h-auto  max-w-[250px] fade-in transition-[1s] absolute  top-0  md:flex hidden ${
          title === 'landing_fdwapp_cta' ? 'left-40' : 'left-50'
        }`}
        bg="linear-gradient(290deg,  #F742A240 25%, #F742A2 33%, #36BBF6CC 88.54%, #36BBF6CC 100%)"
      >
        <div className="w-full  md:min-h-[268px] md:h-[268px] bg-[#120A2A] opacity-95  rounded-[20px] text-white flex flex-col justify-between items-center !h-full p-4">
          <div className="    flex flex-col items-center gap-4 ">
            <QRCode value={url} size={210} level="Q" />
            <h3 className="text-white text-center text-sm font-[600]">
              {t('landing_downloadQR_text')}
            </h3>
          </div>
        </div>
      </CardsLayout>
    </>
  )
}
